<template>
  <div class="alertBox1">
    <dialogWrap
      v-model="show"
      title='新增违章记录'
      :width="'824px'"
      :before-close="submitClose"
      destroy-on-close
    >
      <el-form
        label-position="right"
        :model="formLabelAlign"
        :rules="rules"
        :inline="true"
        ref="recordAdd"
        class="addViolation"
      >
      <el-row>
        <el-col :span="12">
          <el-form-item label="车牌号" prop="carId">
            <CarSelect
              :modelValue="formLabelAlign.carId"
              :getCarDetail="false"
              :plateNo="plateNo"
              @update:modelValue="val => { formLabelAlign.carId = val }"
              @change="getOrderOnTime"></CarSelect>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="违章时间" prop="violationTime">
            <el-date-picker
              v-model="formLabelAlign.violationTime"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="getOrderOnTime"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="相关客户" prop="customerId">
            <el-select
              v-model="formLabelAlign.customerId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="customerRemoteMethod"
              :loading="loading.fuzzy"
              clearable
            >
              <el-option
                v-for="item in optionsName"
                :key="item.id"
                :label="item.customerName"
                :value="item.id"
              >
                <CustomerNameOptionItem :data="item" />
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="'相关订单' + columnSeparator"
            prop="orderId"
          >
            <el-input
              v-number:integer="18"
              placeholder="请输入"
              v-model="formLabelAlign.orderId"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="违章内容" prop="content">
            <el-input
              v-model="formLabelAlign.content"
              v-deleteEmoji="true"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="违章地点" prop="place">
            <el-input
              v-model="formLabelAlign.place"
              v-deleteEmoji="true"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="违章扣分" prop="penaltyPoint">
            <el-input
              v-interage="true"
              v-model="formLabelAlign.penaltyPoint"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="违章罚款" prop="penaltyAmount">
            <el-input
              v-model="formLabelAlign.penaltyAmount"
              v-limit-money="true"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="'备注' + columnSeparator"
            prop="handleRemarks"
          >
            <el-input
              v-deleteEmoji="true"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
              :rows="2"
              placeholder="请输入"
              v-model="formLabelAlign.handleRemarks"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
      <template slot="footer">
        <el-button @click="submitClose" size="small">取消</el-button>
        <el-button type="primary" @click="submitBtn" size="small"
          >确认新增</el-button
        >
      </template>
    </dialogWrap>
  </div>
</template>

<script>
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import {
  ViolationAdd,
  getOrderOnTime,
} from '@/api/domain/carsService'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  components: {
    CustomerNameOptionItem,
  },
  model: {
    prop: 'violationShow',
    event: 'change',
  },
  props: {
    violationShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Object,
      default: () => ({}),
    },
    plateNo: {
      type: String,
      default: '',
    },
    carId: {
      type: [Number, String],
      default: '',
    },
  },
  watch: {
    violationShow(val) {
      this.show = val
    },
    show(val) {
      this.$emit('change', val)
      if (val) {
        this.getCustomerList()
      }
    },
  },
  data() {
    return {
      show: false,
      optionsName: [], // 客户模糊列表

      // 弹框表单的数据
      formLabelAlign: {
        carId: '',
        customerId: '',
        violationTime: '',
        content: '',
        place: '',
        orderId: '',
        penaltyPoint: '',
        penaltyAmount: '',
      },
      rules: {
        carId: [
          { required: true, message: '车牌号不能为空', trigger: ['blur', 'change'] },
        ],
        violationTime: [
          { required: true, message: '时间不能为空', trigger: 'blur' },
        ],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
        penaltyPoint: [
          { required: true, message: '扣分不能为空', trigger: 'blur' },
          { max: 3, message: '扣分最大值为999', trigger: 'blur' },
        ],
        penaltyAmount: [
          { required: true, message: '罚款不能为空', trigger: 'blur' },
          { max: 4, message: '罚款最大值为9999', trigger: 'blur' },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() // 禁用当天之后的时间日期不需要再减时间可以 参考element文档
        },
      },
    }
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    orderTypeList() {
      return this.dictParseList(selectOption.relatedOrderTypeList)
    },
  },
  methods: {
    // 查询相关订单信息
    getOrderOnTime() {
      this.formLabelAlign.customerId = ''
      this.formLabelAlign.orderId = ''
      const { carId, violationTime } = this.formLabelAlign
      if (carId && violationTime) {
        getOrderOnTime({
          time: violationTime,
          carId,
        }).then((res) => {
          const { data } = res
          if (!data) return
          const { customerId, orderId, customerName } = data
          this.optionsName = [{
            id: customerId,
            customerName,
          }]
          this.formLabelAlign.customerId = customerId || ''
          this.formLabelAlign.orderId = orderId || ''
        })
      }
    },
    /* 确认新增按钮 */
    submitBtn() {
      this.$refs.recordAdd.validate((valid) => {
        if (valid) {
          ViolationAdd(this.formLabelAlign).then(() => {
            this.show = false
            this.$refs.recordAdd.resetFields()
            this.$emit('refresh')
          })
        }
      })
    },
    /* 取消新增 */
    submitClose() {
      this.show = false
      this.$refs.recordAdd.resetFields()
    },
    /* 客户模糊搜索 */
    async customerRemoteMethod(query) {
      if (query.trim().length >= 1) {
        // 开启远程搜索
        // eslint-disable-next-line vue/no-mutating-props
        this.getCustomerList(query.trim())
      }
    },
    async getCustomerList(query) {
      // eslint-disable-next-line vue/no-mutating-props
      this.loading.fuzzy = true
      try {
        const { data } = await searchByCustomerNameSensitive({
          customerName: query,
          customerState: 1,
          mixedType: 'YES',
        })
        // 关闭远程搜索
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.fuzzy = false
        this.optionsName = data || []
      } catch (error) {
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.fuzzy = false
      }
    },
  },
  mounted() {
    if (this.carId) {
      this.formLabelAlign.carId = this.carId
    }
  },
}
</script>

<style lang="scss" scoped>
.addViolation {
  ::v-deep .el-input--small {
    width: 220px;
  }

  ::v-deep .el-form-item__label {
    width: 130px;
  }
}
</style>
